import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import EditorsManageWireCallout from '../../../editors-manage-wire/editors-manage-wire-callout';

const Header = styled.div`
  display: flex;
  justify-content: space-between;

  & > .callout {
    display: inline;
    button {
      margin-top: 16px;
      z-index: 1;
      right: 0px;
      > .icon-lw {
        font-size: 18px;
      }
    }
  }

  & > span {
    width: 90%;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: ${props => ((props.theme.isMobile || props.smallText) ? 0 : 5)}px;
    margin-bottom: ${props => (props.smallText ? 0 : 18)}px;

    > a {
      color: ${props => props.theme.bodyColor};
      font-family: ${props => props.theme.fontFamilyHeader};
      font-weight: ${props => props.theme.fontWeightBold};
      ${props => (props.theme.isMobile ? `
        font-size: 18px;
        line-height: 23px;
      ` : `
        font-size: 24px;
        line-height: 31px;
      `)};

      ${props => (props.smallText && `
        display: inline-block;
        line-height: 0px;
        > span {
          font-family: ${props.theme.fontFamilyBody};
          font-weight: ${props.theme.fontWeightHeavy};
          font-size: 14px;
          line-height: 17px;
          text-transform: uppercase;
          height: 32px;
          vertical-align: middle;
        }
      `)}

      ${props => (!props.smallText && `
        &:hover {
          text-decoration: none;
        }
      `)}
    }
  }
`;

export default function WireTitle({ wire, showEditorManageTools }) {
  const showEditorManageWire = showEditorManageTools
    && (_.get(window, 'Livewire.currentUser.profile.canModifyWiresOfOthers') || wire.ownedByCurrentUser);
  const calloutWire = {
    wire_id: wire.id,
    title: wire.title,
    editors_picked: wire.editorsPicked,
    published_at: wire.publishedAt,
    featured_count: wire.featuredCount || 0,
    wire: {
      slug: wire.slug,
      user_id: wire.userId || 0,
      profile: {
        profile_picture_url: _.get(wire, 'profile.profilePicrtureUrl'),
        name: _.get(wire, 'profile.name'),
        organisation: _.get(wire, 'profile.organisation'),
      },
    },
  };

  return (
    <Header>
      <span>
        <a href={`/wires/${wire.slug}`} data-event-type="click" data-event="link_click">
          {wire.title}
        </a>
      </span>
      {showEditorManageWire && <EditorsManageWireCallout wire={calloutWire} rightAligned={false} />}
    </Header>
  );
}

WireTitle.propTypes = {
  wire: PropTypes.shape({
    id: PropTypes.number.isRequired,
    userId: PropTypes.number,
    title: PropTypes.string.isRequired,
    slug: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]).isRequired,
    firstPublishedAt: PropTypes.string,
    publishedAt: PropTypes.string,
    ownedByCurrentUser: PropTypes.bool,
    editorsPicked: PropTypes.bool,
    // This is covering draft wire as well. Optional.
    featuredCount: PropTypes.number,
    profile: PropTypes.shape({
      profilePictureUrl: PropTypes.string,
    }),
  }).isRequired,
  showEditorManageTools: PropTypes.bool,
};

WireTitle.defaultProps = {
  showEditorManageTools: true,
};
